import { useState, useEffect } from 'react';
import automatizacioncontrol from '../assets/automatizacioncontrol.jpg';
import controleselectricos from '../assets/controleselectricos.jpg';
import materialeselectricos from '../assets/materialeselectricos.jpg';
import neumatica from '../assets/neumatica.jpg';
import perfilesposter from '../assets/perfilesposter.png';
import teflonesposter from '../assets/teflonesposter.png';
import tornillosinoxidablesposter from '../assets/tornillosinoxidablesposter.png';
import herramientasposter from '../assets/herramientasposter.jpg';
import loclineposter from '../assets/LOCLINEposter.png';
import estanteriasposter from '../assets/estanteriaposter.png';


//Departametos iconos
import iconautomatizacion from '../assets/automatizacion.jpg';
import iconcontroles from '../assets/controles.jpg';
import iconmelectricos from '../assets/melectricos.jpg';
import iconneumatica from '../assets/neumaicaico.jpg';
import iconperfiles from '../assets/paluminio.jpg';
import iconteflones from '../assets/teflonesico.jpg';
import icontornillosinoxidables from '../assets/tonillosInoxidables.jpg';
import iconherramientas from '../assets/herramientasico.jpg';
import iconlocline from '../assets/tonillosInoxidables.jpg';
import iconestanterias from '../assets/paluminio.jpg';

const departments = [
  { 
    title: 'Neumática', 
    description: 'Cilindros, válvulas, conexiones y sistemas completos para control de fluidos.',
    image: neumatica, // Imagen para Neumática
    // icon: (
    //   <svg className="w-16 h-16 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
    //   </svg>
    // )
    icon: <img src={iconneumatica} alt="Neumática" className="w-16 h-16 object-contain" />
  },
  { 
    title: 'Automatización y Controles', 
    description: 'PLCs, sensores, actuadores, HMI, variadores de frecuencia y sistemas de control de procesos.',
    image: automatizacioncontrol, // Imagen para Automatización y Controles
    icon: <img src={iconautomatizacion} alt="Automatizacion" className="w-16 h-16 object-contain" />
  },
  { 
    title: 'Tornillos Inoxidables', 
    description: 'Amplia gama de tornillería de acero inoxidable para alta resistencia a la corrosión.',
    image: tornillosinoxidablesposter, // Imagen para Tornillos Inoxidables
    icon: <img src={icontornillosinoxidables} alt="Tornillos Inoxidables" className="w-16 h-16 object-contain" />
  },
  { 
    title: 'Teflones', 
    description: 'Materiales de PTFE y otros polímeros de alto rendimiento para sellado y baja fricción.',
    image: teflonesposter, // Imagen para Teflones
    icon: <img src={iconteflones} alt="Teflones" className="w-16 h-16 object-contain" />
  },
  { 
    title: 'Perfiles de Aluminio', 
    description: 'Sistemas modulares de perfiles de aluminio para estructuras, estaciones de trabajo, accesorios y más.',
    image: perfilesposter, // Imagen para Perfiles de Aluminio
    icon: <img src={iconperfiles} alt="Perfiles de Aluminio" className="w-16 h-16 object-contain" />
  },
  { 
    title: 'Materiales Eléctricos', 
    description: 'Distribución de materiales eléctricos esenciales para instalaciones industriales, incluyendo cables, contactores, interruptores, protecciones, canalizaciones y accesorios.',
    image: materialeselectricos, // Imagen para Materiales Eléctricos
    icon: <img src={iconmelectricos} alt="Materiales Eléctricos" className="w-16 h-16 object-contain" />
  },
  {
    title: 'Herramientas',
    description: 'Amplia variedad de herramientas manuales y eléctricas para mantenimiento, montaje y trabajos industriales de precisión.',
    image: herramientasposter, // Imagen para Herramientas
    icon: <img src={iconherramientas} alt="Herramientas" className="w-16 h-16 object-contain" />
  },
  {
  title: 'Loc-Line',
  description: 'Sistemas modulares de mangueras y accesorios Loc-Line ideales para refrigeración, aspiración de humos y direccionamiento de fluidos en procesos industriales.',
  image: loclineposter, // Imagen para Loc-Line
  icon: <img src={iconlocline} alt="Loc-Line" className="w-16 h-16 object-contain" />
},
{
  title: 'Estanterías Metálicas y Rampas Industriales',
  description: 'Soluciones resistentes y versátiles para almacenamiento y logística, incluyendo estanterías metálicas de alta capacidad y rampas industriales seguras para carga y descarga.',
  image: estanteriasposter, // Imagen para Estanterías
  icon: <img src={iconestanterias} alt="Estanterías" className="w-16 h-16 object-contain" />
}
];

const HomeDepartmentsSection = ({ setCurrentPage, setDepartmentName }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('home-departments');
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleExploreClick = (deptTitle) => {
    setDepartmentName(deptTitle);
    setCurrentPage('department');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="home-departments" className="py-20 px-4 bg-gray-100">
      <div className="max-w-6xl mx-auto">
        <h2 className={`text-4xl font-bold text-center text-gray-900 mb-16 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          Nuestros <span className="text-red-600">Departamentos Especializados</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {departments.map((dept, index) => (
            <div 
              key={index} 
              className={`bg-white rounded-xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-500 delay-${index * 100} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={dept.image} 
                  alt={dept.title} 
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
              </div>
              <div className="p-8 text-center">
                <div className="flex justify-center mb-6">
                  {dept.icon}
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">{dept.title}</h3>
                <p className="text-gray-600 leading-relaxed">{dept.description}</p>
                <button 
                  onClick={() => handleExploreClick(dept.title)}
                  className="mt-8 text-red-600 font-medium hover:text-red-800 transition-colors flex items-center justify-center mx-auto group"
                >
                  Ver más 
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default HomeDepartmentsSection;

// DONE